"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fr_FR = _interopRequireDefault(require("../locale/fr_FR"));
var _default = exports["default"] = _fr_FR["default"];